import { Form, Modal, Select } from 'antd';
import styled from 'styled-components';
import { useEffect, useState } from 'react';

const { Option } = Select;
const StyledDiv = styled.div``;

interface DirectWorkerDownloadXlsxModalProps {
  visible: boolean;
  monthList: string[];
  onDownload: (value: any) => void;
  onCancel: () => void;
}

function DirectWorkerDownloadXlsxModal({
  visible,
  monthList,
  onDownload,
  onCancel,
}: DirectWorkerDownloadXlsxModalProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [monthListOptions, setMonthListOptions] = useState<any[]>();

  useEffect(() => {
    if (!mount) return;
    let children: any = [];

    children = [];
    let index = 0;
    for (const month of monthList) {
      children.push(
        <Option key={index++} value={month}>
          {month}
        </Option>,
      );
    }
    setMonthListOptions(children);

    return () => setMount(false);
  }, [monthList, mount]);

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="출역현황 다운로드 하기"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              // form.resetFields();
              onDownload(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Form layout="vertical" form={form} name="control-hooks">
            <Form.Item
              name="selectedMonth"
              label="기간(년/월) 선택"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select>{monthListOptions}</Select>
            </Form.Item>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default DirectWorkerDownloadXlsxModal;
